<template>
  <div class="marketing">
    <component :is="item" v-for="item in items" :key="item.name" class="margin-bottom-1" />
  </div>
</template>

<script>
  import i18n from './locales'

  export default {
    name: 'Marketing',
    i18n,
    props: {
      position: {
        default: null,
        type: String,
      },
    },
    data () {
      return {
        items: [],
      }
    },
    methods: {
      async registerComponentsForCurrentRoute () {
        const definition = this.$theme.getMarketing(this.$route.name)

        if (!definition) return

        const components = definition[this.position] || []

        for (const resolver of components) {
          const module = await resolver()

          if (module.default) {
            this.$set(this.$options.components, module.default.name, module.default)
            this.items.push(this.$options.components[module.default.name])
          }
        }
      },
    },
    created () {
      this.registerComponentsForCurrentRoute()
    },
  }
</script>
